<template>
    <div class="pro_head">
        <div class="logo">
            <img src="../../../assets/logo.png" />
        </div>
        <day-time ref="time"/>
        <div class="box">
            <!--  当前时间 姓名  -->
            
            <welcome ref="welcome" />  
            <acction ref="acction" />
        </div>
    </div>
</template>
<script>
import welcome from "./welcome/welcome";
import dayTime from "./time/moment"
import acction from "./acction/acction";

export default {
    name: "pro_head",
    components: { welcome, acction,dayTime},
    data() {
        return {};
    },
    mounted() {},
    created() {},
    methods: {}
};
</script>


<style lang="less" scoped>
.pro_head {
    // background: #fff;
    height: 50px;
    float: left;
    width: 100%;
    margin: 2px 0;
    .logo {
        width: 80px;
        background: #fff;
        text-align: center;
        margin: 0px 5px 0 5px;
        box-shadow: 1px 2px 3px #ccc;
        border-radius: 5px;
        float: left;
        img {
            width: auto;
            height: 47px;
        }
    }
    .box {
        width: calc(100% - 95px - 205px);
        height: 100%;
        background: #fff;
        float: left;
        background: #fff;
        box-shadow: 1px 2px 3px #ccc;
        border-radius: 5px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/main/components/Hearder.vue